import * as Actions from '../../../../redux/actions'
import SparklesLogo from "../../../../../src/assets/images/sparkle.png"
import SparklesOutline from "../../../../../src/assets/images/sparkleOutline.png"
import SparklesWhite from "../../../../../src/assets/images/sparkle-white.png"
import {
	BusIcon,
	FlightShapeIcon,
	HotelDuotoneIcon,
	MapDuotoneIcon,
	SubwayIcon,
} from "../SVGBank"

import PriceLineBookingFormElement from './PriceLineBookingFormElement'
import { PropTypes } from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faRoute } from '@fortawesome/free-solid-svg-icons'
import AiChatBox from '../AiChatBox/AiChatBox'
import AiChatBoxEmbedded from '../AiChatBox/AiChatBoxEmbedded'
import { environment } from '../../../../Environments/environment'

const BookingForm_ = ({ activeTab, setBookingFormActiveTab, is_mobile }) => {


	return (
		<div>
			<div className="col-md-12">
				<div className="row tabSelection">



					{ <div className={activeTab === 'muvGpt' ? "col-2 col-xs-2 col-sm-2 col-md-2 p-0 tabs-manual activeTab" : "col-2 col-xs-2 col-sm-2 col-md-2 p-0 tabs-manual"} style={{ display: is_mobile ? "block" : "flex",width:130 }} onClick={() => setBookingFormActiveTab('muvGpt')}>

					{is_mobile &&
								<img src={activeTab === 'muvGpt' ? SparklesLogo: SparklesWhite} height={25} width={25} style={{marginTop:0}}
								alt="sparkles" />}

						<h4>
							{!is_mobile &&
								<img src={activeTab === 'muvGpt' ? SparklesLogo: SparklesWhite} height={25} width={25} style={{marginTop:0}}
								alt="sparkles" />}
							Ask müvGPT
						</h4>
					</div>}

					<div className={activeTab === 'planNewTrip' ? "col-2 col-xs-2 col-sm-2 col-md-2 p-0 tabs-manual activeTab" : "col-2 col-xs-2 col-sm-2 col-md-2 p-0 tabs-manual"} style={{ display: is_mobile ? "block" : "flex" }} onClick={() => setBookingFormActiveTab('planNewTrip')}>
						{/* {is_mobile && <FontAwesomeIcon icon={faRoute} fill={activeTab === 'planNewTrip' ? 'var(--mainGreen)' : 'white'}
							width={15} height={15} style={{ marginRight: "0px", marginBottom: "0px" }} />} */}
								{is_mobile && <img src={activeTab === 'planNewTrip' ? SparklesLogo: SparklesOutline} height={25} width={25} style={{marginTop:0}}
							alt="sparkles" />}
						<h4>
							{!is_mobile &&
								 <img src={activeTab === 'planNewTrip' ? SparklesLogo: SparklesOutline} height={25} width={25} style={{marginTop:0,marginLeft:-10,marginRight:10}}
								 alt="sparkles" />}

							Plan a trip
						</h4>
					</div>
					<div className={activeTab === 'plan a trip' ? "col-2 col-xs-2 col-sm-2 col-md-2 p-0 tabs-manual activeTab" : "col-2 col-xs-2 col-sm-2 col-md-2 p-0 tabs-manual"} style={{ display: is_mobile ? "block" : "flex" }} onClick={() => setBookingFormActiveTab('plan a trip')}>
						{is_mobile && <MapDuotoneIcon width={19} height={15} style={{ marginRight: "0px", marginTop: "0px" }} fill={activeTab === 'plan a trip' ? 'var(--mainGreen)' : 'white'} />}
						<h4>
							{!is_mobile && <MapDuotoneIcon width={19} height={15} style={{ marginRight: "5px", marginBottom: "2px" }} fill={activeTab === 'plan a trip' ? 'var(--mainGreen)' : 'white'} />}
							{is_mobile ? "Explore" : "Explore"}
						</h4>
					</div>

					<div className={activeTab === 'hotel' ? "col-2 col-xs-2 col-sm-2 col-md-2 p-0 tabs-manual activeTab" : "col-2 col-xs-2 col-sm-2 col-md-2 p-0 tabs-manual"} style={{ display: is_mobile ? "block" : "flex" }} onClick={() => setBookingFormActiveTab('hotel')}>
						{is_mobile && <HotelDuotoneIcon width={19} height={15} style={{ marginRight: "0px", marginTop: "0px" }} fill={activeTab === 'hotel' ? 'var(--mainGreen)' : 'white'} />}
						<h4>
							{!is_mobile && <HotelDuotoneIcon width={19} height={15} style={{ marginRight: "5px", marginBottom: "2px" }} fill={activeTab === 'hotel' ? 'var(--mainGreen)' : 'white'} />}
							{"Hotel"}
						</h4>
					</div>
					<div className={activeTab === 'flight' ? "col-2 col-xs-2 col-sm-2 col-md-2 p-0 tabs-manual activeTab" : "col-2 col-xs-2 col-sm-2 col-md-2 p-0 tabs-manual"} style={{ display: is_mobile ? "block" : "flex" }} onClick={() => setBookingFormActiveTab('flight')}>
						{is_mobile && <FlightShapeIcon width={19} height={15} style={{ marginRight: "0px", marginTop: "0px" }} fill={activeTab === 'flight' ? 'var(--mainGreen)' : 'white'} />}
						<h4>
							{!is_mobile && <FlightShapeIcon width={19} height={15} style={{ marginRight: "5px", marginBottom: "2px" }} fill={activeTab === 'flight' ? 'var(--mainGreen)' : 'white'} />}
							{"Flight"}
						</h4>
					</div>
					{/* <div className={activeTab === 'train' ? "col-2 col-xs-2 col-sm-2 col-md-2 p-0 tabs-manual activeTab" : "col-2 col-xs-2 col-sm-2 col-md-2 p-0 tabs-manual"} style={{ display: is_mobile ? "block" : "flex" }} onClick={() => setBookingFormActiveTab('train')}>
						{is_mobile && <SubwayIcon width={19} height={15} style={{ marginRight: "0px", marginTop: "0px" }} fill={activeTab === 'train' ? 'var(--mainGreen)' : 'white'} />}
						<h4>
							{!is_mobile && <SubwayIcon width={19} height={15} style={{ marginRight: "5px", marginBottom: "2px" }} fill={activeTab === 'train' ? 'var(--mainGreen)' : 'white'} />}
							{"Train"}
						</h4>
					</div>
					<div className={activeTab === 'bus' ? "col-2 col-xs-2 col-sm-2 col-md-2 p-0 tabs-manual activeTab" : "col-2 col-xs-2 col-sm-2 col-md-2 p-0 tabs-manual"} style={{ display: is_mobile ? "block" : "flex" }} onClick={() => setBookingFormActiveTab('bus')}>
						{is_mobile && <BusIcon width={19} height={15} style={{ marginRight: "0px", marginTop: "0px" }} fill={activeTab === 'bus' ? 'var(--mainGreen)' : 'white'} />}
						<h4>
							{!is_mobile && <BusIcon width={19} height={15} style={{ marginRight: "5px", marginBottom: "2px" }} fill={activeTab === 'bus' ? 'var(--mainGreen)' : 'white'} />}
							{"Bus"}
						</h4>
					</div> */}

				</div>
			</div>

			<div className="col-md-12 p-0">
				<PriceLineBookingFormElement />
			</div>

			{activeTab === 'muvGpt'   &&<div className="col-md-12 p-0">
				<AiChatBoxEmbedded/>
			</div>}
			


		</div >
	)

}

BookingForm_.propTypes = {
	bodyClientWidth: PropTypes.number.isRequired,
}

const mapStateToProps = (state) => {
	return {
		bodyClientWidth: state.Setting.htmlBody.bodyClientWidth,
		bodyClientHeight: state.Setting.htmlBody.bodyClientHeight,

		activeTab: state.FormBank.BookingForm.activeTab,

		uuid: state.Member.authModal.uuid,
		is_mobile: state.Setting.is_mobile,
	}

}

const mapDispatchToProps = {
	setBookingFormActiveTab: Actions.setBookingFormActiveTab,
}
const BookingForm = connect(mapStateToProps, mapDispatchToProps)(BookingForm_)

export default BookingForm